import React from 'react';
import {
  Drawer as MuiDrawer,
  List,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  styled,
  Tooltip,
  Chip,
  Badge,
  Collapse,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  Dashboard as DashboardIcon,
  AttachMoney as AttachMoneyIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  ExpandLess,
  ExpandMore,
  Group as GroupIcon,
  TrendingUp as TrendingUpIcon,
  Security as SecurityIcon,
  Warning as WarningIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Assessment as AssessmentIcon,
  HealthAndSafety as HealthIcon
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const SideDrawer = ({ open, handleDrawerClose, drawerWidth }) => {
  const location = useLocation();
  const { hasRole } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [openEquipes, setOpenEquipes] = useState(false);
  const [openConfig, setOpenConfig] = useState(false);
  
  // Verificar se o usuário tem a role Admin
  const isAdmin = hasRole('admin');
  
  const menuItems = [
    // Menu Administrador só aparece se o usuário tiver a role Admin
    ...(isAdmin ? [{ text: 'Administrador', icon: <AdminPanelSettingsIcon />, to: '/admin' }] : []),
    { text: 'Visão Geral', icon: <DashboardIcon />, to: '/' },
    { text: 'Cards', icon: <AssessmentIcon />, to: '/cards' },
    // { text: 'Mapa de Operações', icon: <MapIcon /> },
    // { text: 'Análise de Desempenho', icon: <BarChartIcon /> },
    { text: 'Financeiro', icon: <AttachMoneyIcon />, to: '/financeiro' },
    // { text: 'Relatórios', icon: <AssignmentIcon /> },
  ];

  const secondaryMenuItems = [
    // Configuracoes agora eh submenu separado (renderizado abaixo)
    { text: 'Ajuda', icon: <HelpIcon /> },
  ];

  return (
    <MuiDrawer
      variant={isMobile ? 'temporary' : 'permanent'}
      open={open}
      onClose={handleDrawerClose}
      ModalProps={{
        keepMounted: true, // Melhor performance em mobile
      }}
      sx={(theme) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(isMobile && {
          '& .MuiDrawer-paper': {
            width: drawerWidth,
          },
        }),
        ...(!isMobile && open && {
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
          },
        }),
        ...(!isMobile && !open && {
          '& .MuiDrawer-paper': {
            transition: theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7),
            [theme.breakpoints.up('sm')]: {
              width: theme.spacing(9),
            },
            boxSizing: 'border-box',
          },
        }),
      })}
    >
      <DrawerHeader>
        {open && (
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', pl: 2 }}>
            <Typography variant="h6" noWrap component="div">
              NEO PARTNERSHIP
            </Typography>
          </Box>
        )}
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {menuItems.map((item, index) => (
          <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={item.to ? Link : 'button'}
              to={item.to}
              onClick={() => {
                if (isMobile && item.to) {
                  handleDrawerClose();
                }
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                backgroundColor: item.to && (location.pathname === item.to || location.pathname.startsWith(item.to + '/')) ? 'rgba(0, 204, 136, 0.08)' : 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(0, 204, 136, 0.12)',
                },
              }}
            >
              <Tooltip title={!open ? item.text : ""} placement="right">
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: item.to && (location.pathname === item.to || location.pathname.startsWith(item.to + '/')) ? 'primary.main' : 'text.secondary',
                  }}
                >
                  {item.notifications ? (
                    <Badge badgeContent={item.notifications} color="error">
                      {item.icon}
                    </Badge>
                  ) : (
                    item.icon
                  )}
                </ListItemIcon>
              </Tooltip>
              {open && (
                <ListItemText 
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontWeight: location.pathname === item.to ? 600 : 400,
                          color: location.pathname === item.to ? 'primary.main' : 'text.primary'
                        }}
                      >
                        {item.text}
                      </Typography>
                      {item.notifications && (
                        <Chip 
                          label={item.notifications} 
                          color="error" 
                          size="small" 
                          sx={{ height: 20, minWidth: 20, fontSize: '0.75rem' }} 
                        />
                      )}
                    </Box>
                  } 
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
        {/* Submenu Equipes */}
        <ListItem disablePadding sx={{ display: 'block' }}>
<ListItemButton
            onClick={() => setOpenEquipes(!openEquipes)}
            sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
          >
            <Tooltip title={!open ? "Equipes" : ""} placement="right">
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <GroupIcon />
              </ListItemIcon>
            </Tooltip>
            {open && (
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Equipes
                    </Typography>
                  </Box>
                }
              />
            )}
            {openEquipes ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openEquipes} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                component={Link}
                to="/equipes/alertas"
                selected={location.pathname === '/equipes/alertas'}
                onClick={() => {
                  if (isMobile) {
                    handleDrawerClose();
                  }
                }}
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <WarningIcon />
                </ListItemIcon>
                <ListItemText primary="Alertas" />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/equipes/performance"
                selected={location.pathname === '/equipes/performance'}
                onClick={() => {
                  if (isMobile) {
                    handleDrawerClose();
                  }
                }}
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <TrendingUpIcon />
                </ListItemIcon>
                <ListItemText primary="Performance" />
              </ListItemButton>
              <ListItemButton
                disabled
                onClick={(e) => e.preventDefault()}
                sx={{ 
                  pl: 4,
                  opacity: 0.6,
                  cursor: 'not-allowed',
                  '&:hover': {
                    backgroundColor: 'transparent'
                  }
                }}
              >
                <ListItemIcon sx={{ opacity: 0.5 }}>
                  <SecurityIcon />
                </ListItemIcon>
                <ListItemText 
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2">Inspeções de Segurança</Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.secondary',
                          fontSize: '0.75rem',
                          fontStyle: 'italic',
                          opacity: 0.7
                        }}
                      >
                        (Em breve)
                      </Typography>
                    </Box>
                  } 
                />
              </ListItemButton>
            </List>
          </Collapse>
        </ListItem>
      </List>
      <Divider />
      <List>
        {/* Submenu Configurações com Health */}
        <ListItem disablePadding sx={{ display: 'block' }}>
          <ListItemButton
            onClick={() => setOpenConfig(!openConfig)}
            sx={{
              minHeight: 48,
              justifyContent: open ? 'initial' : 'center',
              px: 2.5,
            }}
          >
            <Tooltip title={!open ? "Configurações" : ""} placement="right">
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <SettingsIcon />
              </ListItemIcon>
            </Tooltip>
            {open && (
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Configurações
                  </Typography>
                }
              />
            )}
            {open && (openConfig ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
          <Collapse in={openConfig && open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                component={Link}
                to="/configuracoes/health"
                selected={location.pathname === '/configuracoes/health'}
                onClick={() => { if (isMobile) handleDrawerClose(); }}
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <HealthIcon />
                </ListItemIcon>
                <ListItemText primary="Health" />
              </ListItemButton>
            </List>
          </Collapse>
        </ListItem>

        {secondaryMenuItems.map((item, index) => (
          <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              disabled
              onClick={(e) => e.preventDefault()}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                opacity: 0.6,
                cursor: 'not-allowed',
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }}
            >
              <Tooltip title={!open ? item.text : ""} placement="right">
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    opacity: 0.5
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              </Tooltip>
              {open && (
                <ListItemText 
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="body2">{item.text}</Typography>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.secondary',
                          fontSize: '0.75rem',
                          fontStyle: 'italic',
                          opacity: 0.7
                        }}
                      >
                        (Em breve)
                      </Typography>
                    </Box>
                  } 
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </MuiDrawer>
  );
};

export default SideDrawer;
